import { useRef, useState } from "react";
import { FileText, Trash2, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useList } from "@/components/admin/kit";

export function KnowledgeDocs({ home, t, base = "/admin/knowledge" }) {
  const [docs, reload] = useList(base);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const scope = home?.id || "";
  const mine = (docs || []).filter((d) => (d.house_type_id || "") === scope);
  const upload = async (files) => {
    setBusy(true);
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      fd.append("house_type_id", scope);
      try {
        const { data } = await api.post(base, fd);
        toast.success(`${data.name} added${data.truncated ? " (very long, so only the first 40,000 characters are used)" : ""}`);
      } catch (e) { toast.error(`${f.name}: ${errMsg(e)}`); }
    }
    setBusy(false);
    if (input.current) input.current.value = "";
    reload();
  };
  const del = async (d) => {
    if (!window.confirm(`Remove ${d.name}? The assistant will stop using it.`)) return;
    await api.delete(`${base}/${d.id}`);
    reload();
  };
  return (
    <div className="rounded-3xl bg-white border p-6 space-y-3" data-testid="knowledge-docs">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div><p className="font-semibold">Documents {home ? `for ${home.name} only` : `for all ${t.items}`}</p>
          <p className="text-xs text-slate-500">Upload a PDF, Word, text or CSV file (price lists, menus, service lists, policies). The assistant reads it and answers from it.</p></div>
        <input ref={input} type="file" multiple accept=".pdf,.docx,.txt,.md,.csv" className="hidden" onChange={(e) => upload([...e.target.files])} data-testid="knowledge-file-input" />
        <button onClick={() => input.current?.click()} disabled={busy} className="h-10 px-4 rounded-xl bg-slate-900 text-white text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-60" data-testid="knowledge-upload">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}{busy ? "Reading…" : "Upload document"}</button>
      </div>
      {mine.length === 0 && <p className="text-sm text-slate-400">No documents yet.</p>}
      {mine.map((d) => (
        <div key={d.id} className="flex items-center gap-3 rounded-xl border px-3 py-2 text-sm" data-testid={`knowledge-doc-${d.id}`}>
          <FileText className="w-4 h-4 text-slate-400 shrink-0" />
          <span className="flex-1 min-w-0 truncate font-medium">{d.name}</span>
          <span className="text-xs text-slate-500 shrink-0">{d.chars.toLocaleString()} chars{d.truncated ? " · partly used" : ""}</span>
          <button onClick={() => del(d)} className="p-1.5 text-rose-600 hover:bg-rose-50 rounded-lg" data-testid={`knowledge-delete-${d.id}`}><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
    </div>
  );
}
